import type { PropertyFolder } from "../models/propertyFolder";

type FolderLink = Pick<PropertyFolder, "id" | "id_parent">;

/**
 * Ids du dossier d'un bien puis de tous ses dossiers parents, du plus proche
 * au plus lointain. Vide si le bien n'est rattaché à aucun dossier.
 */
export function getPropertyFolderChain(
  folderId: number | null | undefined,
  foldersById: Record<number, FolderLink> | undefined,
): number[] {
  const chain: number[] = [];
  let current = folderId ?? undefined;
  while (current !== undefined && !chain.includes(current)) {
    chain.push(current);
    current = foldersById?.[current]?.id_parent ?? undefined;
  }
  return chain;
}
